/*
 *
 * AccountPage constants
 *
 */

export const DEFAULT_ACTION = 'src/AccountPage/DEFAULT_ACTION';
export const PATCH_ACCOUNT_REQUEST  = 'src/AccountPage/PATCH_ACCOUNT_REQUEST';
export const PUT_ACCOUNT_SUCCESS    = 'src/AccountPage/PUT_ACCOUNT_SUCCESS';
export const PUT_ACCOUNT_FAILURE    = 'src/AccountPage/PUT_ACCOUNT_FAILURE';
export const RESEND_EMAIL_CONFIRMATION =  'src/AccountPage/RESEND_EMAIL_CONFIRMATION';
export const RESEND_EMAIL_CONFIRMATION_SUCCESS =  'src/AccountPage/RESEND_EMAIL_CONFIRMATION_SUCCESS';
export const RESEND_EMAIL_CONFIRMATION_FAILURE =  'src/AccountPage/RESEND_EMAIL_CONFIRMATION_FAILURE';
export const DELETE_ACCOUNT_REQUEST = 'src/AccountPage/DELETE_ACCOUNT_REQUEST';
export const DELETE_ACCOUNT_SUCCESS = 'src/AccountPage/DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_FAILURE = 'src/AccountPage/DELETE_ACCOUNT_FAILURE';

